import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "../components/BrandMark";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]" data-testid="thank-you-page">
      <header className="max-w-6xl mx-auto px-6 lg:px-10 pt-8">
        <BrandMark />
      </header>

      <main className="max-w-2xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="w-14 h-14 rounded-full bg-[#010082]/10 flex items-center justify-center">
          <CheckCircle2 className="w-7 h-7 text-[#010082]" strokeWidth={1.5} />
        </div>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1A1A1A] mt-8 tracking-tight leading-tight">
          Thank you. Your checklist is in.
        </h1>
        <p className="text-[16px] text-[#4A4A4A] mt-6 leading-relaxed">
          Louis will personally review your submission and reach out shortly with next
          steps — a home valuation, marketing plan, and timeline built around your
          goals.
        </p>
        <div className="mt-10 rounded-xl border border-[#E5E5E0] bg-white p-6">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#010082]">
            What happens next
          </div>
          <ul className="mt-4 space-y-3 text-[14px] text-[#1A1A1A]">
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-[#010082] text-white text-[11px] flex items-center justify-center flex-shrink-0">
                1
              </span>
              We confirm receipt within one business day.
            </li>
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-[#010082] text-white text-[11px] flex items-center justify-center flex-shrink-0">
                2
              </span>
              A private consult to review value, prep, and marketing.
            </li>
            <li className="flex gap-3">
              <span className="w-6 h-6 rounded-full bg-[#010082] text-white text-[11px] flex items-center justify-center flex-shrink-0">
                3
              </span>
              A tailored listing plan aligned to your ideal timeline.
            </li>
          </ul>
        </div>
        <div className="mt-10">
          <Link
            to="/"
            className="text-[13px] uppercase tracking-[0.2em] text-[#010082] hover:opacity-70 transition-opacity"
            data-testid="return-home-link"
          >
            ← Return home
          </Link>
        </div>
      </main>
    </div>
  );
}
